import {
    EmployeeLeavingRequestDTO,
    ScheduleEmployeeLeavingRequest,
    UpdateEmployeeCompanyLeavingDateRequest
} from '@iota/inh-core-v1-management-client';
import { createAction, props } from '@ngrx/store';

export const LoadAllEmployeeLeavingRequestsByCompany = createAction(
    '[EmployeeLeaving] LoadAllEmployeeLeavingRequestsByCompany',
    props<{ companyId: string }>()
);
export const LoadAllEmployeeLeavingRequestsByCompanySuccess = createAction(
    '[EmployeeLeaving] LoadAllEmployeeLeavingRequestsByCompanySuccess',
    props<{ employeeLeavingRequests: EmployeeLeavingRequestDTO[] }>()
);
export const LoadAllEmployeeLeavingRequestsByCompanyFailure = createAction(
    '[EmployeeLeaving] LoadAllEmployeeLeavingRequestsByCompanyFailure',
    props<{ error: any }>()
);

export const ScheduleEmployeeLeaving = createAction(
    '[EmployeeLeaving] ScheduleEmployeeLeaving',
    props<{ request: ScheduleEmployeeLeavingRequest }>()
);
export const ScheduleEmployeeLeavingSuccess = createAction(
    '[EmployeeLeaving] ScheduleEmployeeLeavingSuccess',
    props<{ employeeLeavingRequest: EmployeeLeavingRequestDTO }>()
);
export const ScheduleEmployeeLeavingFailure = createAction('[EmployeeLeaving] ScheduleEmployeeLeavingFailure', props<{ error?: any }>());

export const UpdateEmployeeLeavingDate = createAction(
    '[EmployeeLeaving] UpdateEmployeeLeavingDate',
    props<{ id: string; request: UpdateEmployeeCompanyLeavingDateRequest }>()
);
export const UpdateEmployeeLeavingDateSuccess = createAction(
    '[EmployeeLeaving] UpdateEmployeeLeavingDateSuccess',
    props<{ employeeLeavingRequest: EmployeeLeavingRequestDTO }>()
);
export const UpdateEmployeeLeavingDateFailure = createAction(
    '[EmployeeLeaving] UpdateEmployeeLeavingDateFailure',
    props<{ error?: any }>()
);

export const CancelEmployeeLeaving = createAction('[EmployeeLeaving] CancelEmployeeLeaving', props<{ id: string }>());
export const CancelEmployeeLeavingSuccess = createAction(
    '[EmployeeLeaving] CancelEmployeeLeavingSuccess',
    props<{ employeeLeavingRequest: EmployeeLeavingRequestDTO }>()
);
export const CancelEmployeeLeavingFailure = createAction('[EmployeeLeaving] CancelEmployeeLeavingFailure', props<{ error?: any }>());

export const CalculateLicenseEndDate = createAction('[EmployeeLeaving] CalculateLicenseEndDate', props<{ companyLeavingDate: string }>());
export const CalculateLicenseEndDateSuccess = createAction(
    '[EmployeeLeaving] CalculateLicenseEndDateSuccess',
    props<{ licenseEndDate: string }>()
);
export const CalculateLicenseEndDateFailure = createAction('[EmployeeLeaving] CalculateLicenseEndDateFailure', props<{ error?: any }>());
